import { render, staticRenderFns } from "./epiPicture.vue?vue&type=template&id=2b9502d4&"
import script from "./epiPicture.vue?vue&type=script&lang=js&"
export * from "./epiPicture.vue?vue&type=script&lang=js&"
import style0 from "./epiPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports